import Controller from './admin/lightbox_controller'
export default Controller